import { connect } from 'react-redux';
import ClassRoomPost from './Post';
import { fetchClassRoomPost } from '../../../../../../core/actions/classRoom/content';
import {
  currentClassRoomId,
  classRoomName,
  scheduledPostCount,
  nextScheduledPostId,
} from '../../../../../../core/selectors/classroom';
import { sendViewPostAnalytic } from '../../../../../../core/utils/analytics';
import { post as getPost } from '../../../../../../core/selectors/posts';
import goToFeed from '../../../../../actions/navigation/goToFeed';
import openScheduledPosts from '../../../../../actions/navigation/openScheduledPosts';

const mapStateToProps = (state, ownProps) => {
  const postId = ownProps.routeParams.id;

  return {
    spaceId: currentClassRoomId(state),
    spaceName: classRoomName(state),
    postId,
    post: getPost(state, postId),
    scheduledPostCount: scheduledPostCount(state),
    nextScheduledPostId: nextScheduledPostId(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchPost: (spaceId, postId) => async () => {
    const post = await dispatch(fetchClassRoomPost(postId));
    if (!post) {
      dispatch(goToFeed(spaceId));
    }
  },
  openScheduledPosts: () => dispatch(openScheduledPosts()),
  sendViewPostAnalytic,
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  fetchPost: dispatchProps.fetchPost(stateProps.spaceId, stateProps.postId),
});

const ClassRoomPostContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ClassRoomPost);

export default ClassRoomPostContainer;
